module.exports = __webpack_public_path__ + "static/media/twa_sat.be8faa4c.webp";